// import { useContext } from 'react'

// import LanguageContext from '../context/language'

export const useTranslation = () => {
  // const { language } = useContext(LanguageContext)

  // return language
  return 'en'
}